import { render } from "./carusel-section.vue?vue&type=template&id=f8fcf1d6"
import script from "./carusel-section.vue?vue&type=script&lang=js"
export * from "./carusel-section.vue?vue&type=script&lang=js"

import "./carusel-section.vue?vue&type=style&index=0&id=f8fcf1d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__